module.exports = __webpack_public_path__ + "img/grand_stores_logo.d63ddd39.jpeg";